import { Fragment, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonQualificationsCrumbs } from 'system/constants/common-qualifications-crumbs';
import OperatorEdit from 'system/components/operators/edit';
import { useParams, useNavigate, generatePath } from 'react-router';

const OperatorEditPageQualificationsEdit = (): React.ReactElement => {
  const params = useParams();
  const navigate = useNavigate();

  const onSuccess = useCallback(() => {
    navigate(generatePath('/sistema/qualifiche/modifica/:id', params));
  }, [navigate]);

  const onCancel = useCallback(() => {
    navigate(generatePath('/sistema/qualifiche/modifica/:id', params));
  }, [navigate]);

  return (
    <Fragment>
      <Breadcrumbs
        items={[
          ...CommonQualificationsCrumbs,
          { name: 'Modifica Qualifica', path: '/sistema/qualifiche/modifica/:id' },
          { name: 'Modifica Operatore' },
        ]}
      />
      <OperatorEdit onSuccess={onSuccess} onCancel={onCancel} id={params.idOperatore} />
    </Fragment>
  );
};

OperatorEditPageQualificationsEdit.displayName = 'Operator Edit page component from Qualifications';

export default OperatorEditPageQualificationsEdit;
